import { render, staticRenderFns } from "./WarningBadge.vue?vue&type=template&id=23b36f7b&scoped=true"
import script from "./WarningBadge.vue?vue&type=script&lang=js"
export * from "./WarningBadge.vue?vue&type=script&lang=js"
import style0 from "./WarningBadge.vue?vue&type=style&index=0&id=23b36f7b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b36f7b",
  null
  
)

export default component.exports